import { ReactComponent as NoFavorites } from '../../images/no-favorites.svg'

const NoFavoritesComp = () => {
  return (
    <div className='twsf-flex twsf-flex-col twsf-items-center twsf-mt-4'>
      <div className='twsf-m-auto'>
        <NoFavorites />
      </div>
      <div className='twsf-flex twsf-flex-col twsf-items-center twsf-text-sm twsf-mt-2 twsf-text-[#A6ADB2]'>
        <p className='twsf-font-bold twsf-mb-1 twsf-text-[#E4E8EB]'>No Favorites Yet</p>
        <span> Click the star on any menu item </span>
        <span> to add a favorite</span>
      </div>
    </div>
  )
}

export default NoFavoritesComp
